module.exports = __webpack_public_path__ + "img/icon_01.378d3eed.gif";